export enum StepPath {
  HOME = '/home',
  NRF = '/precheckin/guests',
  ARRIVAL_TIME = '/precheckin/time-arrival',
  SUMMARY = '/precheckin/summary',
  CONFIRMATION = '/precheckin/confirmation',
}